import getCardTypeFromBrand from '../../utils/getCardTypeFromBrand';

export default function populatePayoutCardForm(formData, data = {}) {
  const result = {
    ...formData,
  };

  const details = data.details;

  if (details.type) {
    result.type = details.type;
  }

  if (details.cardBrand) {
    result.cardType = getCardTypeFromBrand(details.cardBrand);
  }

  if (details.lastFour) {
    result.cardNumber = details.lastFour.toString();
  }

  if (details.expirationMonth) {
    result.expirationMonth = details.expirationMonth < 10 ?
      `0${details.expirationMonth}` : details.expirationMonth.toString();
  }

  if (details.expirationYear) {
    result.expirationYear = details.expirationYear.toString();
  }

  if (details.postalCode) {
    result.zipCode = details.postalCode.toString();
  }

  result.valid = false;

  result.paymentOption = data;

  return result;
}
